import { OemRateWindowUnit } from '@evimo/types/enums/oem-rate-window-unit';

export const DEFAULT_OEM_RATES = [
  {
    windowValue: 1,
    windowUnit: OemRateWindowUnit.DAY,
    costAmount: 0,
    currency: 'EUR',
  },
  {
    windowValue: 3,
    windowUnit: OemRateWindowUnit.DAY,
    costAmount: 0,
    currency: 'EUR',
  },
  {
    windowValue: 7,
    windowUnit: OemRateWindowUnit.DAY,
    costAmount: 0,
    currency: 'EUR',
  },
];
